import { Card, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { CSSProperties, forwardRef, PropsWithRef, ReactNode, Ref } from "react";

export type StepMenuLandingCardProps = {
    children: ReactNode;
    style?: CSSProperties;
    sx?: SxProps<Theme> | undefined;
    isDragging?: boolean;
};

function StepMenuLandingCard({
    children,
    style,
    sx,
    isDragging,
    ...rest
}: PropsWithRef<StepMenuLandingCardProps>, ref: Ref<HTMLDivElement>) {

    return (
        <Card
            ref={ref}
            style={{
                 ...style,
                  marginLeft: "8px",
                  marginRight: "8px",
             }}
            sx={{
                opacity: isDragging ? theme => theme.palette.action.disabledOpacity : 1,
                display:"flex",
                flexDirection: "column",
                flexGrow: 1,
                flexShrink: 0,
                ...sx
            }}
            {...rest}
            elevation={1}
        >
            {children}
        </Card>
    );
}

export default forwardRef(StepMenuLandingCard);